###
* Unobtrusive autocomplete
*
* To use it, you just have to include the HTML attribute autocomplete
* with the autocomplete URL as the value
*
*   Example:
*       <input type="text" data-autocomplete="/url/to/autocomplete">
*
* Optionally, you can use a jQuery selector to specify a field that can
* be updated with the element id whenever you find a matching value
*
*   Example:
*       <input type="text" data-autocomplete="/url/to/autocomplete" data-id-element="#id_field">
###

do (jQuery) ->
  self = null

  jQuery.fn.railsAutocomplete = (selector) ->

    handler = ->
      if !@railsAutoCompleter
        @railsAutoCompleter = new (jQuery.railsAutocomplete)(this)
      return

    if jQuery.fn.on != undefined
      if !selector
        return
      jQuery(document).on 'focus', selector, handler
    else
      @live 'focus', handler

  jQuery.railsAutocomplete = (e) ->
    _e = e
    @init _e
    return

  jQuery.railsAutocomplete.options =
    showNoMatches: true
    noMatchesLabel: 'no existing match'
  jQuery.railsAutocomplete.fn = jQuery.railsAutocomplete.prototype = railsAutocomplete: '0.0.1'
  jQuery.railsAutocomplete.fn.extend = jQuery.railsAutocomplete.extend = jQuery.extend
  jQuery.railsAutocomplete.fn.extend init: (e) ->

    split = (val) ->
      val.split e.delimiter

    extractLast = (term) ->
      split(term).pop().replace /^\s+/, ''

    e.delimiter = jQuery(e).attr('data-delimiter') or null
    e.min_length = jQuery(e).attr('data-min-length') or jQuery(e).attr('min-length') or 2
    e.append_to = jQuery(e).attr('data-append-to') or null
    e.autoFocus = jQuery(e).attr('data-auto-focus') or false
    jQuery(e).autocomplete
      appendTo: e.append_to
      autoFocus: e.autoFocus
      delay: jQuery(e).attr('delay') or 0
      source: (request, response) ->
        firedFrom = @element[0]
        params = term: extractLast(request.term)
        if jQuery(e).attr('data-autocomplete-fields')
          jQuery.each jQuery.parseJSON(jQuery(e).attr('data-autocomplete-fields')), (field, selector) ->
            params[field] = jQuery(selector).val()
            return
        jQuery.getJSON jQuery(e).attr('data-autocomplete'), params, ->
          options = {}
          jQuery.extend options, jQuery.railsAutocomplete.options
          jQuery.each options, (key, value) ->
            if options.hasOwnProperty(key)
              attrVal = jQuery(e).attr('data-' + key)
              options[key] = if attrVal then attrVal else value
            return
          if arguments[0].length == 0 and jQuery.inArray(options.showNoMatches, [
              true
              'true'
            ]) >= 0
            arguments[0] = []
            arguments[0][0] =
              id: ''
              label: options.noMatchesLabel
          jQuery(arguments[0]).each (i, el) ->
            obj = {}
            obj[el.id] = el
            jQuery(e).data obj
            return
          response.apply null, arguments
          jQuery(firedFrom).trigger 'railsAutocomplete.source', arguments
          return
        return
      change: (event, ui) ->
        if !jQuery(this).is('[data-id-element]') or jQuery(jQuery(this).attr('data-id-element')).val() == ''
          return
        jQuery(jQuery(this).attr('data-id-element')).val(if ui.item then ui.item.id else '').trigger 'change'
        if jQuery(this).attr('data-update-elements')
          update_elements = jQuery.parseJSON(jQuery(this).attr('data-update-elements'))
          data = if ui.item then jQuery(this).data(ui.item.id.toString()) else {}
          if update_elements and jQuery(update_elements['id']).val() == ''
            return
          for key of update_elements
            element = jQuery(update_elements[key])
            if element.is(':checkbox')
              if data[key] != null
                element.prop 'checked', data[key]
            else
              element.val(if ui.item then data[key] else '').trigger 'change'
        return
      search: ->
        # custom minLength
        term = extractLast(@value)
        if term.length < e.min_length
          return false
        return
      focus: ->
        # prevent value inserted on focus
        false
      select: (event, ui) ->
        # first ensure value is a string
        ui.item.value = ui.item.value.toString()
        if ui.item.value.toLowerCase().indexOf('no match') != -1 or ui.item.value.toLowerCase().indexOf('too many results') != -1
          jQuery(this).trigger 'railsAutocomplete.noMatch', ui
          return false
        terms = split(@value)
        # remove the current input
        terms.pop()
        # add the selected item
        terms.push ui.item.value
        # add placeholder to get the comma-and-space at the end
        if e.delimiter != null
          terms.push ''
          @value = terms.join(e.delimiter)
        else
          @value = terms.join('')
          if jQuery(this).attr('data-id-element')
            jQuery(jQuery(this).attr('data-id-element')).val(ui.item.id).trigger 'change'
          if jQuery(this).attr('data-update-elements')
            data = ui.item
            new_record = if ui.item.value.indexOf('Create New') != -1 then true else false
            update_elements = jQuery.parseJSON(jQuery(this).attr('data-update-elements'))
            for key of update_elements
              if jQuery(update_elements[key]).attr('type') == 'checkbox'
                if data[key] == true or data[key] == 1
                  jQuery(update_elements[key]).attr 'checked', 'checked'
                else
                  jQuery(update_elements[key]).removeAttr 'checked'
              else
                if new_record and data[key] and data[key].indexOf('Create New') == -1 or !new_record
                  jQuery(update_elements[key]).val(data[key]).trigger 'change'
                else
                  jQuery(update_elements[key]).val('').trigger 'change'
        remember_string = @value
        jQuery(this).bind 'keyup.clearId', ->
          if jQuery.trim(jQuery(this).val()) != jQuery.trim(remember_string)
            jQuery(jQuery(this).attr('data-id-element')).val('').trigger 'change'
            jQuery(this).unbind 'keyup.clearId'
          return
        jQuery(e).trigger 'railsAutocomplete.select', ui
        false
    jQuery(e).trigger 'railsAutocomplete.init'
    return
  jQuery(document).ready ->
    jQuery('input[data-autocomplete]').railsAutocomplete 'input[data-autocomplete]'
    return
  return

# ---
# generated by js2coffee 2.2.0